import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  configList: {},
  isLoading: false,
  error: "",
  hasData: false
};
const checkinConfigSlice = createSlice({
  name: "checkinConfig",
  initialState,
  reducers: {
    checkinConfigRequest: state => {
      state.isLoading = true;
    },
    checkinConfigSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.configList = action.payload;
    },
    checkinConfigFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    }
  }
});
export const {
  checkinConfigRequest,
  checkinConfigSuccess,
  checkinConfigFailure
} = checkinConfigSlice.actions;
export default checkinConfigSlice.reducer;